// extracted by mini-css-extract-plugin
export var description = "ProductHighlight-module--description--F+5MH";
export var image = "ProductHighlight-module--image--d-2xU";
export var label = "ProductHighlight-module--label--GGqlD";
export var metadata = "ProductHighlight-module--metadata--IYkPE";
export var price = "ProductHighlight-module--price--s6Lbp";
export var title = "ProductHighlight-module--title--M3HQd";
export var wrapper = "ProductHighlight-module--wrapper--E-1a2";